<template>
  <nav class="navbar navbar-expand-lg">
    <div class="container-fluid">
      <a :key="index" v-for="path in this.paths" :href="path[0]">&nbsp;/&nbsp;{{path[1]}}</a>
      <ul class="navbar-nav ml-auto">
        <li class="nav-item">
          <!--          <a class="nav-link" href="#">-->
          <!--            Account-->
          <!--          </a>-->
        </li>
        <li class="nav-item">
          {{ email }}
          <a class="nav-link" v-on:click="logout">
            Log out
          </a>
        </li>
      </ul>
    </div>
  </nav>
</template>
<script>
  import EventBus from '../event-bus'
  import mainTitle from '../layout/DashboardLayout'

  export default {
    computed: {
      routeName() {
        const {name} = this.$route;
        return this.capitalizeFirstLetter(name)
      }
    },
    mounted() {
      this.email = localStorage.getItem('email')

      EventBus.$on('EVENT_PATHS', data => {
      console.log(data);
        this.paths = data;
      });
    },
    data() {
      return {
        activeNotifications: false,
        email: '',
        paths: []
      }
    },
    methods: {
      capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1)
      },
      toggleNotificationDropDown() {
        this.activeNotifications = !this.activeNotifications
      },
      closeDropDown() {
        this.activeNotifications = false
      },
      toggleSidebar() {
        this.$sidebar.displaySidebar(!this.$sidebar.showSidebar)
      },
      hideSidebar() {
        this.$sidebar.displaySidebar(false)
      },
      logout() {
        localStorage.setItem('isAdmin', null);
        localStorage.setItem('email', null);
        this.$http.get('auth/logout')
          .then(result => {
            this.$router.push('/auth/login');
          }, error => {
            console.error(error);
          });
      }
    }
  }

</script>
<style>

</style>
